export default "__VITE_ASSET__D2H8jcxi__"